var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOcrTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.357,
    height: 21.846,
    viewBox: "0 0 20.357 21.846",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16271",
    "data-name": "Group 16271",
    transform: "translate(-10.4 -7.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18986",
    "data-name": "Path 18986",
    d: "M24.186,10.4V7.5H16.664v2.9H10.4v1.566h1.874l1.335,17.38H27.292l1.335-17.38h2.131V10.4ZM22.645,9.04v1.335H18.23V9.04ZM15.021,27.755,13.814,11.941H27.035L25.8,27.755Z",
    transform: "translate(0 0)",
    fill: "#e0272b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4938",
    "data-name": "Rectangle 4938",
    width: 1.566,
    height: 11.372,
    transform: "translate(19.642 14.2)",
    fill: "#e0272b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4939",
    "data-name": "Rectangle 4939",
    width: 11.398,
    height: 1.566,
    transform: "translate(22.52 25.535) rotate(-86.892)",
    fill: "#e0272b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4940",
    "data-name": "Rectangle 4940",
    width: 1.566,
    height: 11.398,
    transform: "matrix(0.999, -0.054, 0.054, 0.999, 16.146, 14.239)",
    fill: "#e0272b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOcrTrash);
export default __webpack_public_path__ + "static/media/ocr_trash.a74b8ba361abd0517cddc70671ba2f6b.svg";
export { ForwardRef as ReactComponent };